import { render } from "./SliderImage.vue?vue&type=template&id=883dc3aa&scoped=true"
import script from "./SliderImage.vue?vue&type=script&lang=js"
export * from "./SliderImage.vue?vue&type=script&lang=js"

import "./SliderImage.vue?vue&type=style&index=0&id=883dc3aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-883dc3aa"]])

export default __exports__